module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Book-74e01b89955dd7e1d236ad01e9770d02.svg";